const ImagesImported = {
    logo: require("./logo.png"),
}

export default ImagesImported;